import Chartist from "chartist"
import "chartist/dist/chartist.css"

export default Chartist
